<button nz-button nzType="text">
  <i nz-icon>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M5.5028 5.12704L5.5 7.25V17.7542C5.5 19.5491 6.95507 21.0042 8.75 21.0042L17.3663 21.0045C17.0573 21.8782 16.224 22.5042 15.2444 22.5042H8.75C6.12665 22.5042 4 20.3776 4 17.7542V7.25C4 6.26929 4.62745 5.43512 5.5028 5.12704ZM17.75 2.5C18.9926 2.5 20 3.50736 20 4.75V17.75C20 18.9926 18.9926 20 17.75 20H8.75C7.50736 20 6.5 18.9926 6.5 17.75V4.75C6.5 3.50736 7.50736 2.5 8.75 2.5H17.75ZM17.75 4H8.75C8.33579 4 8 4.33579 8 4.75V17.75C8 18.1642 8.33579 18.5 8.75 18.5H17.75C18.1642 18.5 18.5 18.1642 18.5 17.75V4.75C18.5 4.33579 18.1642 4 17.75 4Z"
        fill="#505760"
      />
    </svg>
  </i>
</button>
